export default "__VITE_PUBLIC_ASSET__40359707__"